import React, { Fragment, useEffect, useState, useCallback } from "react";
import { set_orders } from "../../../redux/actions/OrdersAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../../../redux/actions/LayoutAction";
import TableList from "./TableList";
import Header from "../subheader/Header";
import HeaderTab from "./tab/HeaderTab";
import "./orders.scss";
import { debounce } from "lodash";

const Orders = (props) => {
  const [data, setData] = useState(false);
  const [headerList, setHeaderList] = useState([]);
  const [tabTitle, settabTitle] = useState("all");
  const [searchText, setSearchText] = useState("");

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Orders";
  }, []);

  const tabName = (tab) => (tab === "all" ? "" : "&with_status=" + tab);

  const getOrders = (page, params) => {
    document.getElementById("rightContent").scrollTop = 0;
    setData(false);
    apiJson.orders.getOrders(page, params).then((response) => {
      if (response.success) {
        props.set_orders({
          orders: response.data.orders,
          pagination: response.data.pagination,
        });
        setData(true);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  };
  const ChangeTabList = (title) => {
    if (title !== tabTitle) {
      settabTitle(title);
      getOrders(
        1,
        tabName(title) + (searchText?.length > 0 ? "&search=" + searchText : "")
      );
    }
  };

  const pageChange = (page) => {
    getOrders(
      page,
      tabName(tabTitle) +
        (searchText?.length > 0 ? "&search=" + searchText : "")
    );
  };

  useEffect(() => {
    getOrders(1, searchText?.length > 0 ? "&search=" + searchText : "");

    apiJson.orders.getTabsCount().then((response) => {
      response.success
        ? setHeaderList({
            id: "orderstab",
            tablist: [
              { id: "all", count: response.data.all },
              { id: "pending", count: response.data.pending },
              { id: "cancelled", count: response.data.cancelled },
              { id: "rejected", count: response.data.rejected },
              { id: "processing", count: response.data.processing },
              { id: "shipped", count: response.data.shipped },
              { id: "delivered", count: response.data.delivered },
              {
                id: "partially_returned",
                count: response.data.partially_returned,
              },
              { id: "fully_returned", count: response.data.fully_returned },
            ],
          })
        : setHeaderList({
            id: "orderstab",
            tablist: [
              { id: "all", count: 0 },
              { id: "pending", count: 0 },
              { id: "cancelled", count: 0 },
              { id: "rejected", count: 0 },
              { id: "processing", count: 0 },
              { id: "shipped", count: 0 },
              { id: "delivered", count: 0 },
              { id: "partially_returned", count: 0 },
              { id: "fully_returned", count: 0 },
            ],
          });
    });
    // eslint-disable-next-line
  }, []);

  const debouncedCallback =
    // eslint-disable-next-line
    useCallback(
      debounce((text, currTab) => handleSearch(text, currTab), 1000),
      []
    );

  const handleSearch = (text, tab) => {
    getOrders(1, tabName(tab) + "&search=" + text);
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right order-page-container w-100">
        <Header
          heading="Orders"
          search={true}
          filters={null}
          handleSearch={(text) => {
            setSearchText(text);
            debouncedCallback(text, tabTitle);
          }}
        />
        <div className="right-content content-container-row w-100">
          <div className="content mx-auto">
            <HeaderTab
              currTab={tabTitle}
              onTabChoose={ChangeTabList}
              tab={headerList}
            >
              <TableList
                List={props.orders}
                pageChange={pageChange}
                pagination={props.pagination}
              />
            </HeaderTab>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    pagination: state.order.pagination,
    orders: state.order.orders,
    load: state.layout.isLoading,
  };
};

const mapDispatchToProps = { set_orders, set_loading };

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
